import { Injectable } from '@angular/core';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs';

export class ProductInfo {
  product: string;
  brand: string;
  platform: string;
}

@Injectable()
export class CurrentProductService {

  constructor(
    private readonly urlBuilder: UrlBuilderService,
    private readonly http: HttpClient
  ) {}

  getProductPlatform(): Observable<ProductInfo> {
    return this.http.get<ProductInfo>(this.urlBuilder.getUrl("productinfo"));
  }

}
